import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../../actions/application';
import { APPLICATION_CONTEXTS } from '../../../constants';
import { ImageButtonList } from '../../common/imageButtonList';
import ImageButton from '../../common/imageButton';
import '../styles.css';

class CategoryButtonList extends ImageButtonList {
  /*********************
   * Protected methods *
   *********************/

  /**
   * Builds this component's representation of the desired button list.
   *
   * @protected
   *
   * @param {object[]}  [buttons=this.props.imageButtons]  The buttons to process.
   *
   **/
  buildImageButtons = (currentButton = this.state.currentButton, props = this.props) => {
    let classes = 'main-menu-links';
    const buttons = Array.from(props.imageButtons);
    this.setState({
      currentButton: currentButton,
      buttons: buttons.map((button, index) => (
        <ImageButton
          key={button.id}
          className={classes}
          hl={this.props.hl}
          uh={this.props.uh}
          {...button}
          current={index === currentButton}
          disabled={props.disabled || props.unfocused || button.disabled}
          resetCurrent={this.resetCurrent}
        />
      ))
    });
  };

  findEnabledButton = direction => {
    let currentButton = this.state.currentButton;
    let buttons = this.props.imageButtons.slice();
    if(direction === this.ARROW_UP) {
      buttons = buttons.reverse();
      currentButton = this.props.imageButtons.length - 1 - currentButton;
    }
    let foundIndex = buttons.findIndex((button, buttonIndex) => {
      const match = !button.disabled && buttonIndex > currentButton;
      return match;
    });
    foundIndex = foundIndex === -1 ? currentButton : foundIndex;
    if(direction === this.ARROW_UP) {
      foundIndex = this.props.imageButtons.length - 1 - foundIndex;
    }
    return foundIndex;
  };

  handleOnKeyUp = event => {
    if (this.props.unfocused || this.props.disabled || this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    if (this.props.handleKeyUp) {
      this.props.handleKeyUp(this.state.currentButton, event.key);
    }
    let current = null;
    switch (event.key) {
      case 'ArrowDown':
        current = this.findEnabledButton(this.ARROW_DOWN);
        this.buildImageButtons(current);
        break;
      case 'ArrowUp':
        current = this.findEnabledButton(this.ARROW_UP);
        this.buildImageButtons(current);
        break;
      default:
    }
  };
}

export default connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(CategoryButtonList);
